export default "__VITE_ASSET__DE9b_otu__$_?url__"